import { wait } from '../common'
const ajaxWait = 0

const slider = document.querySelector('#form-tom')
const dom = {
  serverMessage: '.server-message',
  step1: '#tom-step-1',
  step2: '#tom-step-2',
  step3: '#tom-step-3',
  step4: '#tom-step-4',
  societe: '#tom-societe',
  lastname: '#tom-lastname',
  firstname: '#tom-firstname',
  email: '#tom-email',
  mobile: '#tom-mobile',
  om_titre: '#tom-om_titre',
  om_objet: '#tom-om_objet',
  om_context: '#tom-om_context',
  om_skills: '#tom-om_skills',
  om_social: '#tom-om_social',
  om_profile: '#tom-om_profile',
  om_place: '#tom-om_place',
  om_duration: '#tom-om_duration',
  om_debut: '#tom-om_debut',
  om_honoraires: '#tom-om_honoraires',
  om_commission: '#tom-om_commission',
  rgpd: '#tom-rgpd',
  newsom: '#tom-newsletter',
  process: '.process',
  continue: ['.continue'],
  back: ['.back'],
}

if (slider) {
  // query dom objects
  for (const [k, v] of Object.entries(dom)) {
    if (typeof v === 'string') dom[k] = slider.querySelector(v)
    if (Array.isArray(v)) dom[k] = slider.querySelectorAll(v[0])
  }

  // step back
  for (const item of slider.querySelectorAll('.back')) {
    item.addEventListener('click', (e) => {
      dom.serverMessage.innerHTML = ''
      window.scrollTo({ top: sliderTop(), left: 0, behavior: 'smooth' })
      slider.dispatchEvent(new Event('prev'))
    })
  }

  // step next
  for (const item of slider.querySelectorAll('.continue')) {
    item.addEventListener('click', (e) => {
      dom.serverMessage.innerHTML = ''
      window.scrollTo({ top: sliderTop(), left: 0, behavior: 'smooth' })
      slider.dispatchEvent(new Event('next'))
    })
  }

  // process
  dom.process.addEventListener('click', send)

  // init inputs
  dom.societe.value = ''
  dom.lastname.value = ''
  dom.firstname.value = ''
  dom.email.value = ''
  dom.mobile.value = ''

  dom.om_titre.value = ''
  dom.om_objet.value = ''
  dom.om_context.value = ''
  dom.om_place.value = ''
  dom.om_duration.value = ''
  dom.om_debut.value = ''
  dom.om_honoraires.value = ''
  dom.om_commission.value = ''

  dom.om_skills.value = ''
  dom.om_social.value = ''
  dom.om_profile.value = ''
  dom.rgpd.checked = false
  dom.newsom.checked = true

  slider.dispatchEvent(new Event('refresh'))
}

async function send() {
  if (!dom.rgpd.checked) {
    dom.serverMessage.innerHTML =
      'Votre consentement à la loi RGPD est nécessaire'
    dom.rgpd.focus()
    return
  }

  dom.process.disabled = true
  dom.serverMessage.innerHTML = 'envoi en cours...'
  await wait(ajaxWait)

  const url = new URL(slider.dataset.url)
  url.searchParams.set('action', slider.dataset.action)
  url.searchParams.set('nonce', slider.dataset.nonce)
  url.searchParams.set('step', 'send')
  url.searchParams.set('societe', dom.societe.value)
  url.searchParams.set('lastname', dom.lastname.value)
  url.searchParams.set('firstname', dom.firstname.value)
  url.searchParams.set('email', dom.email.value)
  url.searchParams.set('mobile', dom.mobile.value)
  url.searchParams.set('om_titre', dom.om_titre.value)
  url.searchParams.set('om_objet', dom.om_objet.value)
  url.searchParams.set('om_context', dom.om_context.value)
  url.searchParams.set('om_place', dom.om_place.value)
  url.searchParams.set('om_duration', dom.om_duration.value)
  url.searchParams.set(
    'om_debut',
    dom.om_debut.value.replace(/^(\d{4})-(\d{2})-(\d{2})/, '$3-$2-$1')
  )
  url.searchParams.set('om_honoraires', dom.om_honoraires.value)
  url.searchParams.set('om_commission', dom.om_commission.value)
  url.searchParams.set('om_skills', dom.om_skills.value)
  url.searchParams.set('om_social', dom.om_social.value)
  url.searchParams.set('om_profile', dom.om_profile.value)
  url.searchParams.set('newsom', dom.newsom.value)

  let response
  try {
    response = await fetch(url)
    dom.process.disabled = false
  } catch (error) {
    dom.process.disabled = false
    dom.serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  // http error
  if (!response.ok) {
    dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  if (json.data.odoo_error) {
    dom.serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (json.success === false) {
    const prop = Object.keys(json.data)[0] || null
    if (prop && dom[prop]) {
      dom[prop].select()
      dom[prop].focus()
      const step = dom[prop].closest('.step')
      if (step) step.dispatchEvent(new Event('navigate'))
    }
    dom.serverMessage.innerHTML = json.data[prop] || 'Erreur'
    return
  }

  if (!json.data.response.valid) {
    if (json.data.response.missingfields) {
      const prop = json.data.response.missingfields[0] || null
      if (prop && dom[prop]) {
        dom[prop].select()
        dom[prop].focus()
        const step = dom[prop].closest('.step')
        if (step) step.dispatchEvent(new Event('navigate'))
      }
    }
    if (json.data.response.errors?.length > 0) {
      const lines = json.data.response.errors.map((el) => `<div>${el}</div>`)
      dom.serverMessage.innerHTML = lines.join('')
    }
  } else {
    dom.step1.dataset.status = 'hidden'
    dom.step2.dataset.status = 'hidden'
    dom.step3.dataset.status = 'hidden'
    dom.step4.dataset.status = ''
    dom.step4.querySelector('.titre-annonce').innerHTML = dom.om_titre.value
    dom.step4.dispatchEvent(new Event('navigate'))
  }
}

function sliderTop() {
  return (
    Math.ceil(slider.getBoundingClientRect().top) +
    document.documentElement.scrollTop -
    parseInt(getComputedStyle(slider).getPropertyValue('scroll-margin-top'), 10)
  )
}
